var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"refundability"},[_c('vb-icon',{staticClass:"refundability__icon",attrs:{"name":_vm.refundable.icon,"color":_vm.sass(_vm.refundable.variant),"size":16}}),_c('span',{class:'refundability__text refundability__text--' + _vm.refundable.variant},[_vm._v(_vm._s(_vm.refundable.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }